import type { IEmbedConfig } from "~/feature/embed/types";
import { getEmbedUrl } from "~/feature/embed/utils/getEmbedUrl";
import { getPublicSiteOrigin } from "~/utils/getSiteOrigin";

import { EMBED_DEFAULT_SIZE, EMBED_POWERED_BY } from "../constants";

// The snippet leaves this site, so it points at the public origin — the
// preview may run on a preview deployment or localhost, the snippet may not.
export const getEmbedSnippet = (config: IEmbedConfig): string => {
  const { width, height } = config.size ?? EMBED_DEFAULT_SIZE;
  const src = getEmbedUrl(config, getPublicSiteOrigin()).replaceAll(
    "&",
    "&amp;"
  );

  return [
    `<!-- ${EMBED_POWERED_BY} -->`,
    `<iframe src="${src}" width="${width}" height="${height}" style="border:0" loading="lazy" title="${EMBED_POWERED_BY}"></iframe>`,
  ].join("\n");
};
